import { Div, DragScrollX, H3 } from '@vgrubs/components';
import { BestPerformingBrandsSection } from './BestPerformingBrandsSection';
import { BestPerformingCustomersSection } from './BestPerformingCustomersSection';
import { BestPerformingLocationSection } from './BestPerformingLocationSection';
import { BestPerformingProvidersSection } from './BestPerformingProvidersSection';
import { BestPerformingStatesSection } from './BestPerformingStatesSection';

export const LifetimePerformance = () => {
  return (
    <Div>
      <Div $column>
        <H3 $mb="10">Lifetime Performance</H3>
      </Div>
      <DragScrollX>
        <BestPerformingLocationSection />
        <BestPerformingBrandsSection />
        <BestPerformingStatesSection />
        <BestPerformingProvidersSection />
        <BestPerformingCustomersSection />
      </DragScrollX>
    </Div>
  );
};
